module.exports = __webpack_public_path__ + "img/B4.01c36323.svg";